module.exports = __webpack_public_path__ + "img/9.97056a00.png";